import React, { useRef } from "react";
import { Link } from "react-router-dom";
import { useLogin } from "../apiCalls/userApiCalls";
import AuthSplit from "../components/AuthSplit";
import { Button, Input, Label, Spinner } from "../components/ui";

export default function Login() {
  const emailInputElement = useRef();
  const passwordInputElement = useRef();

  const {
    mutate: userMutate,
    isLoading: isUserLoading,
    isError: isUserError,
    error: userError,
  } = useLogin();

  const handleSubmit = (event) => {
    event.preventDefault();
    userMutate({
      email: emailInputElement.current?.value,
      password: passwordInputElement.current?.value,
    });
  };

  return (
    <AuthSplit
      title="Welcome back"
      subtitle="Sign in to manage your profile and track your ranking."
    >
      <form onSubmit={handleSubmit} className="flex flex-col gap-5">
        <div>
          <Label htmlFor="email_field">Email Address</Label>
          <Input
            type="email"
            id="email_field"
            name="email"
            placeholder="Enter your email address"
            ref={emailInputElement}
            required
          />
        </div>

        <div>
          <Label htmlFor="password_field">Password</Label>
          <Input
            type="password"
            id="password_field"
            name="password"
            placeholder="Enter your password"
            ref={passwordInputElement}
            required
          />
        </div>

        {isUserError && (
          <p className="text-sm font-medium text-danger">
            {userError?.response?.data?.error || "Sign in failed."}
          </p>
        )}

        <Button type="submit" size="lg" disabled={isUserLoading}>
          {isUserLoading ? <Spinner size="sm" /> : "Sign In"}
        </Button>

        <p className="text-center text-sm text-muted">
          Don't have an account?{" "}
          <Link
            to="/register"
            className="font-semibold text-primary hover:underline"
          >
            Get ranked
          </Link>
        </p>
      </form>
    </AuthSplit>
  );
}
